import { fileUpload } from '~/services/api/contracts/fileUpload'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { AvatarUploadRequestSchema } from '~/services/api/generated'

const DashboardUploadAvatarSchema = AvatarUploadRequestSchema.extend({
  avatar: fileUpload({ mimes: ['jpeg', 'png', 'jpg', 'gif', 'webp'], maxKb: 5120 })
})

export const DashboardUploadAvatar = (_context: NoContext = {}) => DashboardUploadAvatarSchema
